import { FC, SVGProps } from 'react';

const ReportsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2814 2.30142H6.73727C5.00394 2.29477 3.58311 3.67644 3.54227 5.40894V14.3364C3.50394 16.0973 4.89978 17.5564 6.66061 17.5956C6.68644 17.5956 6.71144 17.5964 6.73727 17.5956H13.3948C15.1398 17.5248 16.5148 16.0831 16.5024 14.3364V6.69811L12.2814 2.30142Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0625 2.29163V4.71579C12.0625 5.89913 13.0192 6.85829 14.2025 6.86163H16.4983"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9067 12.7987H7.40674"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2024 9.67163H7.40576"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReportsIcon;
